// removed by extract-text-webpack-plugin
module.exports = {"Container":"styles__Container___3C19V","Selected":"styles__Selected___3DnAm","SelectedBlock":"styles__SelectedBlock___1Ol_d"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Rates/Switch/styles.scss
// module id = 1411
// module chunks = 0